export default function prepareEmbeddedHomePage(contentDocument) {
  const toRemove = [
    "a[href='/integrations']",
    "div[class='logo']",
    "div[class='sidebar-integ-new single-integration-sidebar mobile']",
    "footer[class='block footer container-fluid']",
    "div[class='right-links-wrapper']",
    "div[class='mobile-bottom-wrapper d-block d-lg-none d-xl-none']",
  ];
  toRemove.forEach(elementQuery => {
    const element = contentDocument.querySelector(elementQuery);
    if (element) {
      element.remove();
    }
  });

  // Remove "get started on github" links
  contentDocument.querySelectorAll("a[target='_blank']").forEach(element => {
    if (element.innerHTML.includes('Get started on Github')) {
      element.remove();
    }
  });

  // Legacy page formatting (the site is a completely different template for these)
  const legacyPages = ['ServiceNow', 'Zendesk Workflow'];
  try {
    // remove unwanted elements
    legacyPages.forEach(page => {
      try {
        contentDocument.querySelector(`img[alt='${page}']`).remove();
      } catch (ignored) {
        // Do nothing, the logo we're looking for isn't here
      }
    });
    contentDocument
      .querySelector("a[href='https://www.xmatters.com/signup']")
      .remove();

    // fix awkward page formatting
    // eslint-disable-next-line no-param-reassign
    contentDocument.querySelector(
      "div[class='block featured-integrations-header text-center']",
    ).style.paddingBottom = 0;
    // eslint-disable-next-line no-param-reassign
    contentDocument.querySelector(
      "div[class='block bg-white value-prop-block value-prop-block-b']",
    ).style.paddingTop = 0;
  } catch (ignored) {
    // Do nothing we're probably not on a legacy page
  }

  // The drift bot is appended to the HTML post-load by an external script
  // I've found that the easiest way to remove it is to monitor the body of
  // the HTML for when the element is added and immediately remove it

  const observer = new MutationObserver((mutationList, obs) => {
    let elementsRemoved = 0;

    mutationList.forEach(mutation => {
      switch (mutation.addedNodes[0]?.id) {
        case 'drift-frame-controller':
          contentDocument.getElementById('drift-frame-controller').remove();
          elementsRemoved += 1;
          if (elementsRemoved === 2) obs.disconnect();
          break;
        case 'drift-frame-chat':
          contentDocument.getElementById('drift-frame-chat').remove();
          elementsRemoved += 1;
          if (elementsRemoved === 2) obs.disconnect();
          break;
        default:
          // do nothing
          break;
      }
    });
  });

  observer.observe(contentDocument.querySelector('body'), {
    attributes: false,
    childList: true,
    subtree: false,
  });
}
